import type { TranslationTable } from "@repo/shared/types";

const EN_GB = {
  month: "Month",
  quarter: "Quarter",
  year: "Year",
  total: "Total",
};

// All 17 locales (QL-17 plan keeps them); the type makes each one match EN_GB.
export const T: TranslationTable<typeof EN_GB> = {
  en_GB: EN_GB,
  fr_FR: {
    month: "Mois",
    quarter: "Trimestre",
    year: "Année",
    total: "Total",
  },
  es_ES: {
    month: "Mes",
    quarter: "Trimestre",
    year: "Año",
    total: "Total",
  },
  pt_BR: {
    month: "Mês",
    quarter: "Trimestre",
    year: "Ano",
    total: "Total",
  },
  de_DE: {
    month: "Monat",
    quarter: "Quartal",
    year: "Jahr",
    total: "Gesamt",
  },
  it_IT: {
    month: "Mese",
    quarter: "Trimestre",
    year: "Anno",
    total: "Totale",
  },
  ar: {
    month: "شهر",
    quarter: "ربع سنة",
    year: "سنة",
    total: "الإجمالي",
  },
  ja_JP: {
    month: "月",
    quarter: "四半期",
    year: "年",
    total: "合計",
  },
  hi_IN: {
    month: "माह",
    quarter: "तिमाही",
    year: "वर्ष",
    total: "कुल",
  },
  zh_CN: {
    month: "月",
    quarter: "季度",
    year: "年",
    total: "合计",
  },
  zh_TW: {
    month: "月",
    quarter: "季",
    year: "年",
    total: "合計",
  },
  nl_NL: {
    month: "Maand",
    quarter: "Kwartaal",
    year: "Jaar",
    total: "Totaal",
  },
  nb_NO: {
    month: "Måned",
    quarter: "Kvartal",
    year: "År",
    total: "Totalt",
  },
  sv_SE: {
    month: "Månad",
    quarter: "Kvartal",
    year: "År",
    total: "Totalt",
  },
  fi_FI: {
    month: "Kuukausi",
    quarter: "Neljännes",
    year: "Vuosi",
    total: "Yhteensä",
  },
  da_DK: {
    month: "Måned",
    quarter: "Kvartal",
    year: "År",
    total: "I alt",
  },
  is_IS: {
    month: "Mánuður",
    quarter: "Ársfjórðungur",
    year: "Ár",
    total: "Samtals",
  },
};
